/* Product Coupon: storefront display only; actual discounts are set up in Shopify Discounts. */
(() => {
  const readTime = (value) => {
    if (!value || !/(Z|[+-]\d{2}:?\d{2})$/i.test(value)) return NaN;
    return Date.parse(value);
  };
  const valid = (candidate, now) => Boolean(candidate && candidate.name && candidate.top && candidate.bottom && candidate.code && Number.isFinite(candidate.end) && candidate.end > now);
  function init(root) {
    if (root.dataset.couponInitialized === 'true') return;
    const json = document.getElementById(`ProductCoupon-${root.dataset.couponBlockId}`);
    if (!json) return;
    let data;
    try { data = JSON.parse(json.textContent); } catch (_) { return; }
    const product = data.product ? { ...data.product, end: readTime(root.dataset.productEnd) } : null;
    const globalCoupon = root.dataset.globalEnabled === 'true' ? { ...data.global, end: readTime(root.dataset.globalEnd) } : null;
    const parts = { title: root.querySelector('[data-coupon-title]'), top: root.querySelector('[data-coupon-top]'), bottom: root.querySelector('[data-coupon-bottom]'), code: root.querySelector('[data-coupon-code]'), remaining: root.querySelector('[data-coupon-remaining]'), copy: root.querySelector('[data-coupon-copy]'), copyLabel: root.querySelector('[data-coupon-copy-label]') };
    let current = null;
    function tick() {
      if (!root.isConnected) return;
      const now = Date.now();
      const next = valid(product, now) ? product : valid(globalCoupon, now) ? globalCoupon : null;
      if (!next) { root.hidden = true; current = null; return; }
      root.hidden = false;
      if (next !== current) {
        current = next;
        parts.title.textContent = next.name;
        parts.top.textContent = next.top;
        parts.bottom.textContent = next.bottom;
        parts.code.textContent = next.code;
        parts.copyLabel.textContent = 'Copy Code';
      }
      const remaining = Math.max(0, Math.ceil((next.end - now) / 1000));
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      const hhmmss = [hours, minutes, seconds].map(n => String(n).padStart(2, '0')).join(':');
      parts.remaining.textContent = days > 0 ? `Ends in ${days} ${days === 1 ? 'Day' : 'Days'} ${hhmmss}` : `Ends in ${hhmmss}`;
    }
    parts.copy.addEventListener('click', async () => {
      if (!current) return;
      try {
        await navigator.clipboard.writeText(current.code);
        parts.copyLabel.textContent = 'Copied';
      } catch (_) {
        parts.copyLabel.textContent = 'Copy failed';
      }
    });
    root.dataset.couponInitialized = 'true';
    tick();
    const timer = window.setInterval(() => {
      if (!root.isConnected) { window.clearInterval(timer); return; }
      tick();
    }, 1000);
  }
  function initialize() { document.querySelectorAll('[data-product-coupon]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
